export default __webpack_public_path__ + "static/media/female_eyes-01.0a62dd9d.png";